import { put, select, takeEvery } from 'redux-saga/effects'
import { Game, Api, Auth, Firebase } from '../../Core'
import * as selectors from './battles.selectors'
import * as actions from './battles.actions'
import * as toastManagerActions from '../Toast/toast.actions'
import * as audioActions from '../../Core/Game/AudioContainer/audio.actions'

import CheckBattle from './CheckBattle'
import AnswerBattle from './AnswerBattle'
import BattleResume from './BattleResume'
import StartBattle from './StartBattle'

export const MAX_QUESTIONS = 5
/**
 */
export function* loadComponents() {
  const components = {
    CheckBattle,
    AnswerBattle,
    BattleResume,
    StartBattle,
  }

  yield put(Game.actions.registerComponents(components))
}

/**
 */
export function* init() {
  yield loadComponents()
}

export function* answerBattleQuestion(action) {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const question = action.data.question
  const individualBattle = yield select(selectors.getIndividualBattle)
  const battle = individualBattle ? individualBattle : yield select(selectors.getCurrentBattle)
  const payload = {
    selectedKey: question.selectedKey,
    groupId: userInfo.licenseData.groupId,
    questionId: question.id,
  }

  try {
    const isRight = yield Api.put(`/battles/${battle.id}`, {}, payload)
    const info = yield select(selectors.getBattleInfoFromState)

    const newInfo = {
      question: info.question < MAX_QUESTIONS ? info.question + 1 : MAX_QUESTIONS,
      hits: isRight.right ? info.hits + 1 : info.hits,
      fails: !isRight.right ? info.fails + 1 : info.fails,
    }
    yield put(actions.setBattleInfo(newInfo))
    yield put(actions.getBattleQuestion())
    yield put(audioActions.playHowlAudio('right_answer'))
  } catch (e) {
    console.log(e)
    yield put(actions.saveBattleError())
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
    yield put(audioActions.playHowlAudio('wrong_answer'))
  }
}

export function* createBattle(action) {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const { rivalId, battleParameters } = action.data

  const payload = {
    building: { ...battleParameters },
    groupId: userInfo.licenseData.groupId,
    prize: 100,
    players: [userInfo.licenseId, rivalId],
  }

  try {
    yield Api.post(`/battles`, {}, payload)
    yield put(actions.saveBattleOk())
    yield put(actions.getOwnBattle())
  } catch (e) {
    console.log(e)
    yield put(
      toastManagerActions.addToast({
        icon: 'icon-desafio',
        label: 'battles.noMoreBattlePlayer',
        cursorPosition: true,
        customClass: 'toast--screen active',
        style: {},
      })
    )
    yield put(actions.saveBattleError())
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

export function* getBattleQuestion() {
  const individualBattle = yield select(selectors.getIndividualBattle)
  const battle = individualBattle ? individualBattle : yield select(selectors.getCurrentBattle)
  const userInfo = yield select(Auth.selectors.getUserInfo)

  try {
    const response = yield Api.get(
      `/battles/${battle.id}/nextQuestion?playerId=${userInfo.licenseId}`,
      {}
    )
    if (!response.battleFinished) {
      yield put(actions.setBattleQuestion(response))
    } else {
      const summary = yield Api.get(`/battles/${battle.id}/summary`, {})

      yield put(
        actions.setBattleResume(
          Object.assign({}, summary[userInfo.licenseId], { building: summary.building })
        )
      )
      yield put(actions.setBattleResults(summary.playerResults))
      yield put(actions.setBattleQuestion(null))
      yield put(Game.actions.removeScreen('battle_screen'))
      yield put(Game.actions.addScreen('battle_resume_screen'))
    }
  } catch (e) {
    yield put(actions.saveBattleError())
    console.log(e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}
export function* getBattle(action) {
  const [, tutorial, lang] = window.location.pathname.split('/')
  if (tutorial !== 'tutorial') {
    const userInfo = yield select(Auth.selectors.getUserInfo)
    const canSet = action.data

    try {
      const battle = yield Api.get(
        `/battles/next?groupId=${userInfo.licenseData.groupId}&playerId=${userInfo.licenseId}&isAttacking=false`,
        {}
      )
      const groupdata = yield select(Firebase.selectors.getGroupData)
      const battles = yield Api.get(
        `/battles?groupId=${userInfo.licenseData.groupId}&players=${userInfo.licenseId}&session=${
          groupdata.session
        }&session=${groupdata.session - 1}`,
        {}
      )
      if (battles) {
        yield put(actions.setUserBattles(battles.docs))
      }
      const allBattles = yield Api.get(
        `/battles?groupId=${userInfo.licenseData.groupId}&players=${userInfo.licenseId}`,
        {}
      )
      if (allBattles) {
        yield put(actions.setAllUserBattles(allBattles.docs))
      }
      if ((battle && Object.keys(battle).length > 0) || canSet) {
        yield put(actions.setBattle(battle))
        const info = yield select(selectors.getBattleInfo)
        yield put(actions.setBattleInfo(info))
        if (battle.results && battle.results[userInfo.licenseId]) {
          yield put(actions.getBattleQuestion())
          yield put(Game.actions.addScreen('battle_screen'))
        }
      }
    } catch (e) {
      yield put(actions.saveBattleError())
      console.log(e)
      if (e && e.status === 401) {
        console.log('Unauthorized')
        yield put(Game.actions.returnToPlatform())
      }
    }
  }
}

export function* getOwnBattle() {
  const userInfo = yield select(Auth.selectors.getUserInfo)

  try {
    const battle = yield Api.get(
      `/battles/next?groupId=${userInfo.licenseData.groupId}&playerId=${userInfo.licenseId}&isAttacking=true`,
      {}
    )
    yield put(actions.setBattle(battle))
    if (battle.id) {
      yield put(Game.actions.addScreen('start_battle_screen'))
      yield put(audioActions.removeHowlAudio())
      yield put(audioActions.playHowlAudio('start_battle_screen'))
    }
  } catch (e) {
    console.log(e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

export function* giveUpBattle() {
  const individualBattle = yield select(selectors.getIndividualBattle)
  const battle = individualBattle ? individualBattle : yield select(selectors.getCurrentBattle)

  try {
    yield Api.put(`/battles/${battle.id}/giveUpBattle`, {})
    yield put(Game.actions.removeScreen('battle_screen'))
    yield put(actions.setBattle(null))
    yield put(actions.setIndividualBattle(null))
  } catch (e) {
    yield put(actions.saveBattleError())
    console.log(e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

/**
 */
export function* sagas() {
  yield init()
  yield takeEvery(actions.CREATE_BATTLE, createBattle)
  yield takeEvery(actions.ANSWER_BATTLE_QUESTION, answerBattleQuestion)
  yield takeEvery(actions.GET_BATTLE_QUESTION, getBattleQuestion)
  yield takeEvery(actions.GET_BATTLE, getBattle)
  yield takeEvery(actions.GET_OWN_BATTLE, getOwnBattle)
  yield takeEvery(actions.GIVE_UP, giveUpBattle)
}
